import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgPinWhite = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 11a7 7 0 119.734 6.446c-1.677.811-2.419 2.541-2.622 3.414-.03.077-.067.14-.112.14s-.078-.063-.1-.14c-.202-.881-.742-2.53-2.556-3.381A7.002 7.002 0 015 11zm9.148 4.807c2.015-.835 3.352-2.768 3.352-4.941C17.5 7.902 15.038 5.5 12 5.5s-5.5 2.402-5.5 5.366c0 2.196 1.365 4.146 3.467 4.99.908.415 1.585.977 2.083 1.644.532-.688 1.217-1.328 2.098-1.693zM8.5 11a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z"
      clipRule="evenodd"
    />
  </svg>
));
SvgPinWhite.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgPinWhite;
